import useAppRoutes from './useAppRoutes'
import useFlattenedRoutes from './useFlattenedRoutes'

export default { useFlattenedRoutes, useAppRoutes }